<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="chap1">ABROGATE</p>
<p class="chap_line"></p>
<p class="center"><span class="big">E</span>xcuses are like raindrops in a cloudburst as they can fall so fast that a flash flood can fabricate And some excuses are truly real that have no appeal but to resolve because there is no excuse not to follow the Master’s plan of salvation; for to do so, heaven you do abrogate.</p>
<p class="center1">The natural man has excuses for every trap and sin that Satan has set for us to be ensnared</p>
<p class="center">And in evil’s mesh spun so very cleverly that you never feel the filthy knife that from the Tree of Knowledge you are pared.</p>
<p class="center1">A truly righteous soul mandates honor and accountability from themselves as well as from those they know</p>
<p class="center">To ensure that the light of Christ’s pure love surrounds them in a brightness that makes the wicked cower and hide their faces from the brilliance of its glow.</p>
<p class="center1">On judgment day, every excuse known to man will be expounded to no avail</p>
<p class="center">For your works, deeds, and testimony are the only keys that will escort you through the veil.</p>
<p class="center1">An excuse is just a way of saying that you are not willing to find another way to accomplish the task that is the goal</p>
<p class="center">For it is a person rare that the task will be accomplished, no matter what the cost,</p>
<p class="center">for they know that their soul is on the line and have the courage to pay the toll.</p>
<p class="center1">Excuses are like raindrops in a cloudburst as they can fall so fast that a flash flood of lies, they can fabricate</p>
<p class="center">And some excuses are truly real that have no appeal but to resolve because there is no excuse not to follow the master’s plan of salvation; for to do so, heaven you do abrogate.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap001.vue?081ecc94